import { PolymerElement } from 'polymer';

/**
 * @customElement
 * @polymer
 * @appliesMixin HIP.BehaviorElement
 */
class PortalElement extends HIP.BehaviorElement(PolymerElement) {
  static get is() {
    return 'hi-portal';
  }

  static get properties() {
    return {
      /**
       * insert the template at `<zi-portal-insertion-point />` in the template
       */

      insertionPoint: Boolean,
      /**
       * the template to insert in to an element
       * do not include `<template>` in your template but just the content
       */

      template: String,
      /**
       * the id/gid of the element to insert a new template in to
       * typically: hi-custom or hi-repeat
       */

      for: String,
      /**
       * used to force an update
       */

      force: {
        type: Number,
        value: 0
      }
    };
  }

  static get api() {
    return ['invoke'];
  }

  static get observers() {
    return ['__requirementsWatcher(template, for, insertionPoint, force)'];
  }

  static get autoBinding() {
    return {
      signal: 'invoke-ended',
      field: 'invoke'
    };
  }

  static get queryInsertionPoint() {
    return /<zi-portal-insertion-point>[\s\S]*?<\/zi-portal-insertion-point>/i;
  }

  connectedCallback() {
    super.connectedCallback();
    this.__captureOriginalTemplate();

    this.setAttribute('hidden', 'hidden');
  }

  /**
   *
   * @param template {String} the template string to stamp or proxy
   */

  invoke(template) {
    this.template = template;
    this.force += 1;
  }

  __captureOriginalTemplate() {
    const templateEl = this.children.item(0);
    if (!templateEl) {
      return;
    }

    this.__initialHTML = templateEl.innerHTML.trim();
  }

  __requirementsWatcher(template, _for, insertionPoint) {
    if (template == null) {
      return;
    } else if (typeof template === 'string') {
      template = {
        content: template
      };
    }

    if (typeof template.content !== 'string') {
      return;
    }

    const forEl = this.queryElement(_for);
    if (!forEl) {
      return;
    }

    const templateCurrentEl = Array.from(forEl.children).find((el) => el.tagName === 'TEMPLATE');

    const newTemplate = insertionPoint
      ? this.__initialHTML.replace(PortalElement.queryInsertionPoint, template.content)
      : template.content;

    if (templateCurrentEl) {
      templateCurrentEl.remove();
    }

    const templateEl = document.createElement('template');

    templateEl.innerHTML = newTemplate;

    forEl.map = template.mapRecord;
    forEl.appendChild(templateEl);
  }
}

HIP.factory.element(PortalElement);
